<div [id]="`line-chart-container-${attribute.name}`" [options]="options"
     [theme]="getChartTheme()"
     echarts></div>
